
const PRODUCTION_API_URL = "https://adventory-api.admongrel.com";

const local = ["localhost", "127.0.0.1"].includes(window.location.hostname);

export const API_URL = local ? "http://localhost:5100" : PRODUCTION_API_URL;
